import { render, staticRenderFns } from "./IconWikipedia.vue?vue&type=template&id=6aefcf7c&"
import script from "./IconWikipedia.vue?vue&type=script&lang=js&"
export * from "./IconWikipedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports